import apiClient from "../core/HttpClient";
import { ContactUs } from "../models";

export default class ContactUsService {
   
  
    url = "/ContactUs";
    async getContactUs() {
        return apiClient.get(this.url).then((response) => {
            return response.data;
        });
    }
    async getContactUsById(id: string) {
        return apiClient.get(`${this.url}/${id}`).then((response) => {
            return response.data;
        });
        
    }
    async createContactUs(data: ContactUs) {
        return apiClient.post(this.url, data);
    }
     updateContactUs(id: string, data: ContactUs) {
        return apiClient.put(`${this.url}/${id}`, data);
        
    }
    async setContactUsReplayed(id:string,replayed:boolean){
        return apiClient.put(`${this.url}/${id}/replayed`,{replayed});
        
    }
}
